import { App, Plugin } from 'vue';
import Language from '@common/store/Language';

export const Translater: Plugin = {
  install(app: App) {
    // eslint-disable-next-line
    app.config.globalProperties.translate = (slug: string, domain = 'messages') => Language.translate((slug || '').toString(), domain);
  },
};
